import { BaseRule, ApplyRule } from './type'

function createUpdateRuleProps<K>({    
    onChange,
    applyRule,
    ruleName
}: {    
    onChange: (rule: BaseRule) => void
    ruleName: string
    applyRule: ApplyRule
}): (props: K) => void {
    return function (k) {
        onChange({
            applyRule,
            ruleName,
            props: k
        })
    }
}

export {createUpdateRuleProps}